import Sidebar from "../components/Sidebar";
import { Card, CardContent } from "../components/ui/card";
import { Clock } from "lucide-react";

export default function HistorialMensajeriaPage() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
      <Sidebar />
      <main className="flex-1 ml-0 md:ml-64 p-4 md:p-8 pt-14 md:pt-8 overflow-x-hidden">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white font-['Manrope']">
            Historial de Mensajería
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1">
            Registro histórico de entregas y recogidas
          </p>
        </div>
        <Card className="dark:bg-slate-800 dark:border-slate-700">
          <CardContent className="py-12 text-center">
            <Clock className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto mb-4" />
            <p className="text-slate-500 dark:text-slate-400">Módulo en desarrollo</p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
